module.exports = __webpack_public_path__ + "static/img/RALZ,C13_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RALZ,C13_1.png
// module id = pavH
// module chunks = 0